// Shared helper for comparing people's names (anglers, members) so that
// case and incidental whitespace differences ("John Smith" vs "john  smith ")
// don't cause the same person to be treated as two different people.
// Only used as a comparison/grouping key — never for display, so the
// originally-typed casing is always what's shown to users.
function normalizeName(str) {
  return String(str || "").trim().replace(/\s+/g, " ").toLowerCase();
}

module.exports = { normalizeName };
